@if (isLoading) {
<div class="section-heading dds-mb-3">
  <div class="section-title">Loading...</div>
</div>
} @else {
<div class="section-heading dds-mb-3">
  <div class="section-title">Upload a New Version of API Specification</div>
  <div class="dds-label greyed-out">
    Upload a new version of the API specification. The name is pre-filled but can be changed.
  </div>
</div>

<div class="input-container dds-mb-3">
  <dds-input
    [formControl]="inputFormCtrl"
    [label]="inputOptions.label"
    [labelPosition]="inputOptions.labelPosition"
    [placeholder]="inputOptions.placeholder"
    [isRequired]="inputOptions.isRequired"
    [isInverse]="inputOptions.isInverse"
    [isError]="inputOptions.isError"
    [readonly]="inputOptions.readonly"
    [size]="inputOptions.size"
    [description]="inputOptions.description"
    [errorMessage]="inputOptions.errorMessage"
    [errorState]="inputOptions.errorState"
    [descriptionType]="inputOptions.descriptionType"
    [maxLength]="inputOptions.maxLength"
    [maxLengthPosition]="inputOptions.maxLengthPosition"
    [textAlign]="inputOptions.textAlign"
    [type]="inputOptions.type"
    (valueChanged)="changeValue()"
    (onBlur)="onBlur()"
  ></dds-input>
</div>

<div class="input-container">
  <dds-uploader
    [heading]="uploadAreaOptions.heading"
    [description]="uploadAreaOptions.description"
    [isDragAndDrop]="uploadAreaOptions.isDragAndDrop"
    [isMultiple]="uploadAreaOptions.isMultiple"
    [maxSize]="uploadAreaOptions.maxSize"
    [maxTotalSize]="uploadAreaOptions.maxTotalSize"
    [maxFiles]="uploadAreaOptions.maxFiles"
    [maxSymbolsName]="uploadAreaOptions.maxSymbolsName"
    [maxSymbolsNameError]="uploadAreaOptions.maxSymbolsNameError"
    [acceptFormats]="uploadAreaOptions.acceptFormats"
    [acceptExtensions]="uploadAreaOptions.acceptExtensions"
    [restrictedFormats]="uploadAreaOptions.restrictedFormats"
    [restrictedExtensions]="uploadAreaOptions.restrictedExtensions"
    [exceptSymbols]="uploadAreaOptions.exceptSymbols"
    [btnLabel]="uploadAreaOptions.btnLabel"
    [isError]="uploadAreaOptions.isError"
    [theme]="uploadAreaOptions.theme"
    [errorMessage]="uploadAreaOptions.errorMessage"
    [itemErrorMessage]="uploadAreaOptions.itemErrorMessage"
    [itemSuccessMessage]="uploadAreaOptions.itemSuccessMessage"
    [knownExtensions]="uploadAreaOptions.knownExtensions"
    [unknownExtensionsIcon]="uploadAreaOptions.unknownExtensionsIcon"
    [customClass]="uploadAreaOptions.customClass"
    [isDownloadable]="uploadAreaOptions.isDownloadable"
    [allowFilesWithoutType]="uploadAreaOptions.allowFilesWithoutType"
    [isRequired]="uploadAreaOptions.isRequired"
    [isInverse]="uploadAreaOptions.isInverse"
    [chooseFileBtnKind]="uploadAreaOptions.chooseFileBtnKind"
    [disabled]="uploadAreaOptions.disabled"
    (uploadedItems)="uploadedItems($event)"
    (removedItem)="removedItem($event)"
  ></dds-uploader>
</div>

<div class="buttons-wrapper">
  <dds-button
    [theme]="cancelButtonOptions.theme"
    [kind]="cancelButtonOptions.kind"
    [size]="cancelButtonOptions.size"
    [width]="cancelButtonOptions.width"
    [icon]="cancelButtonOptions.icon"
    [isIconLeft]="cancelButtonOptions.isIconLeft"
    [role]="cancelButtonOptions.role"
    [isInverse]="cancelButtonOptions.isInverse"
    [isColorBg]="cancelButtonOptions.isColorBg"
    [isLoading]="cancelButtonOptions.isLoading"
    [ariaLabel]="cancelButtonOptions.ariaLabel"
    [customClass]="cancelButtonOptions.customClass"
    (clicked)="cancelClick($event)"
    >Cancel</dds-button
  >

  <dds-button
    [theme]="updateSpecificationButtonOptions.theme"
    [kind]="updateSpecificationButtonOptions.kind"
    [size]="updateSpecificationButtonOptions.size"
    [width]="updateSpecificationButtonOptions.width"
    [icon]="updateSpecificationButtonOptions.icon"
    [isIconLeft]="updateSpecificationButtonOptions.isIconLeft"
    [role]="updateSpecificationButtonOptions.role"
    [isInverse]="updateSpecificationButtonOptions.isInverse"
    [isColorBg]="updateSpecificationButtonOptions.isColorBg"
    [isLoading]="updateSpecificationButtonOptions.isLoading"
    [ariaLabel]="updateSpecificationButtonOptions.ariaLabel"
    [customClass]="updateSpecificationButtonOptions.customClass"
    (clicked)="updateSpecificationClick()"
    >Update API Specification</dds-button
  >
</div>
}
